import axios from "@/axios.js";
import { AlertCircleIcon } from "vue-feather-icons";

export default {
  fetchListOfPendingQuotation({ commit }, filterParams) {
    return new Promise((resolve, reject) => {
      axios
        .get("pendingquotations/data", { params: filterParams })
        .then((response) => {
          commit("SET_PENDING_QUOTATION", response.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  FetchSumalDashboard({ commit }) {
    return new Promise((resolve, reject) => {
      axios
        .get("dashboard/sumal")
        .then((response) => {
          commit("SET_SUMAL_DASHBOARD", response.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  TransactionsOcol({ commit }) {
    return new Promise((resolve, reject) => {
      axios
        .get("transactionsocol/data")
        .then((response) => {
          commit("SET_TRANSACTIONS_OCOL", response.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  refreshMenu({ commit }) {
    return new Promise((resolve, reject) => {
      axios
        .get("anaf/countnewefactura")
        .then((response) => {
          commit("UPDATE_EFACTURA", {
            toBeSent: response.data.tobesend,
            received: response.data.received,
          });
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  // Compteurs casa de marcat. Volontairement SEPARE de refreshMenu : celui-ci
  // interroge l'ANAF et prend plusieurs secondes, alors qu'ici c'est un COUNT
  // local. Les coupler ferait attendre le SPV pour afficher un compteur de base.
  refreshFiscalCounts({ commit }) {
    return new Promise((resolve, reject) => {
      axios
        .get("fiscal/counts")
        .then((response) => {
          commit("UPDATE_FISCAL", {
            pending: response.data.pending,
            indeterminate: response.data.indeterminate,
            vatGroups: response.data.vat_groups_declared,
            agentBlocking: response.data.agent_blocking,
            agent: response.data.agent,
            z: response.data.z,
            register: response.data.register,
          });
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  findTransactionsRon({ commit }) {
    return new Promise((resolve, reject) => {
      axios
        .get("/paymentreminder/unlinkedtransactionsron")
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  findTransactionsEur({ commit }) {
    return new Promise((resolve, reject) => {
      axios
        .get("/paymentreminder/unlinkedtransactionseur")
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  findMatchingBanksInvoices({ commit }) {
    return new Promise((resolve, reject) => {
      axios
        .get("/paymentreminder/seematchwithbanks")
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  fetchReconciliationReport(_, { from, to }) {
    return new Promise((resolve, reject) => {
      axios
        .get("/paymentreminder/reconciliation-report", { params: { from, to } })
        .then((response) => resolve(response))
        .catch((error) => reject(error));
    });
  },
  downloadReconciliationReportPdf(_, { from, to }) {
    return new Promise((resolve, reject) => {
      axios
        .get("/paymentreminder/reconciliation-report-pdf", {
          params: { from, to },
          responseType: "blob",
        })
        .then((response) => {
          const url = window.URL.createObjectURL(
            new Blob([response.data], { type: "application/pdf" })
          );
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", `Payment_Reconciliation_${from}_${to}.pdf`);
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          window.URL.revokeObjectURL(url);
          resolve(response);
        })
        .catch((error) => reject(error));
    });
  },
  fetchSmartMatching() {
    return new Promise((resolve, reject) => {
      axios
        .get("/paymentreminder/smartreconcile")
        .then((response) => resolve(response))
        .catch((error) => reject(error));
    });
  },
  allocateTransaction(_, { idtransaction, allocations, credit_notes }) {
    return new Promise((resolve, reject) => {
      axios
        .post(`/paymentreminder/transactions/${idtransaction}/allocate`, { allocations, credit_notes })
        .then((response) => resolve(response))
        .catch((error) => reject(error));
    });
  },
  unallocateTransaction(_, idtransaction) {
    return new Promise((resolve, reject) => {
      axios
        .post(`/paymentreminder/transactions/${idtransaction}/unallocate`)
        .then((response) => resolve(response))
        .catch((error) => reject(error));
    });
  },
  fetchDashboardOverdueOcolSum({ commit }) {
    return new Promise((resolve, reject) => {
      axios
        .get("/paymentreminder/seeocolsum")
        .then((response) => {
          console.log(response.data[0].tobepaid);
          commit("SET_OCOL_SUM", -response.data[0].tobepaid);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  fetchDashboardOverdueOcolList({ commit }) {
    return new Promise((resolve, reject) => {
      axios
        .get("/paymentreminder/seeocollist")
        .then((response) => {
          commit("SET_OCOL_LIST", response.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  fetchDashboardHarvestingTotalArchived({ commit }) {
    return new Promise((resolve, reject) => {
      axios
        .get("/dashboardharvestingtotalarchived")
        .then((response) => {
          commit("SET_DASHBOARD_HARVESTING_TOTAL_ARCHIVED", response.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  fetchDashboardHarvestingArchived({ commit }) {
    return new Promise((resolve, reject) => {
      axios
        .get("/dashboardharvestingarchived")
        .then((response) => {
          commit("SET_DASHBOARD_HARVESTING_ARCHIVED", response.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  fetchDashboardHarvestingTotalInProgress({ commit }) {
    return new Promise((resolve, reject) => {
      axios
        .get("/dashboardharvestingtotalinprogress")
        .then((response) => {
          commit("SET_DASHBOARD_HARVESTING_TOTAL_IN_PROGRESS", response.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  fetchDashboardHarvestingInProgress({ commit }) {
    return new Promise((resolve, reject) => {
      axios
        .get("/dashboardharvestinginprogress")
        .then((response) => {
          commit("SET_DASHBOARD_HARVESTING_IN_PROGRESS", response.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  fetchSumOfUnpaidInvoiceProvider({ commit }) {
    return new Promise((resolve, reject) => {
      axios
        .get("/paymentreminder/provider/sum/data")
        .then((response) => {
          commit("SET_UNPAID_INVOICE_PROVIDER_SUM", response.data[0].prix);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  fetchListOfUnpaidInvoiceProvider({ commit }) {
    return new Promise((resolve, reject) => {
      axios
        .get("/paymentreminder/provider/data")
        .then((response) => {
          commit("SET_UNPAID_INVOICE_PROVIDER", response.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  fetchDashboardTransportlistforexisting({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios
        .get("/dashboardtransport/listforexistingtransport", item)
        .then((response) => {
          commit("SET_LIST_FOR_EXISTING_TRANSPORT", response.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  createTransportFromDashboard({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios
        .post("/dashboardtransport/createnewtransport", item)
        .then((response) => {
          commit("CREATE_NEW_TRANSPORT", response.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  fetchDashboardTransportwaitingfordepartureDash({ commit }) {
    return new Promise((resolve, reject) => {
      axios
        .get("/dashboardtransport/transportwaitingfordeparturedashboard")
        .then((response) => {
          var transportze = response.data;
          commit("SET_TRANSPORTWAITINGFORDEPARTURE", transportze);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  fetchDashboardTransportwaitingfordeparture({ commit }) {
    return new Promise((resolve, reject) => {
      axios
        .get("/dashboardtransport/transportwaitingfordeparture")
        .then((response) => {
          var transportze = response.data;

          if (Array.isArray(transportze)) {
            const parseDate = (value) => {
              if (!value) return null;
              const date = new Date(value);
              return Number.isNaN(date.getTime()) ? null : date;
            };

            const compareByDateThenId = (first, second) => {
              const dateA = parseDate(first && first.date);
              const dateB = parseDate(second && second.date);

              if (dateA && dateB) {
                if (dateA < dateB) return -1;
                if (dateA > dateB) return 1;
              } else if (dateA) {
                return -1;
              } else if (dateB) {
                return 1;
              }

              const hasIdA =
                first && first.id !== undefined && first.id !== null;
              const hasIdB =
                second && second.id !== undefined && second.id !== null;

              if (hasIdA && hasIdB) {
                const idA = Number(first.id);
                const idB = Number(second.id);

                const validIdA = !Number.isNaN(idA);
                const validIdB = !Number.isNaN(idB);

                if (validIdA && validIdB) {
                  if (idA < idB) return -1;
                  if (idA > idB) return 1;
                  return 0;
                }

                if (validIdA) return -1;
                if (validIdB) return 1;
              } else if (hasIdA) {
                return -1;
              } else if (hasIdB) {
                return 1;
              }

              return 0;
            };

            transportze.sort(compareByDateThenId);
          }

          commit("SET_TRANSPORTWAITINGFORDEPARTURE", transportze);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  fetchDashboardTransportwaitingfordepartureentrant({ commit }) {
    return new Promise((resolve, reject) => {
      axios
        .get("/dashboardtransport/transportwaitingfordepartureentrant")
        .then((response) => {
          var transportze = response.data;
          commit("SET_TRANSPORTWAITINGFORDEPARTUREENTRANT", transportze);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  fetchDashboardTransporttoday({ commit }) {
    return new Promise((resolve, reject) => {
      axios
        .get("/dashboardtransport/transporttoday")
        .then((response) => {
          var transport = response.data;
          commit("SET_TRANSPORTTODAY", transport);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  fetchDashboardTransportEntranttoday({ commit }) {
    return new Promise((resolve, reject) => {
      axios
        .get("/dashboardtransport/transporttodayentrant")
        .then((response) => {
          var transport = response.data;
          commit("SET_TRANSPORTENTRANTTODAY", transport);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  fetchDashboardTransportontheroad({ commit }) {
    return new Promise((resolve, reject) => {
      axios
        .get("/dashboardtransport/transportontheroad")
        .then((response) => {
          var transport = response.data;
          commit("SET_TRANSPORTONTHEROAD", transport);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  fetchDashboardTransportontheroadentrant({ commit }) {
    return new Promise((resolve, reject) => {
      axios
        .get("/dashboardtransport/transportontheroadentrant")
        .then((response) => {
          var transport = response.data;
          commit("SET_TRANSPORTONTHEROADENTRANT", transport);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  fetchListOfUnpaidInvoice({ commit }) {
    return new Promise((resolve, reject) => {
      axios
        .get("/paymentreminder/data")
        .then((response) => {
          var unpaidinvoice = response.data;
          commit("SET_UNPAID_INVOICE", unpaidinvoice);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  fetchListOfUnpaidInvoiceBroker({ commit }) {
    return new Promise((resolve, reject) => {
      axios
        .get("/paymentreminder/data")
        .then((response) => {
          var unpaidinvoice = response.data.filter(invoice => invoice.idbroker == localStorage.getItem('login-broker'));
          commit("SET_UNPAID_INVOICE", unpaidinvoice);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  fetchTotalValueOfUnpaidInvoice({ commit }) {
    return new Promise((resolve, reject) => {
      axios
        .get("/gettotalunpaidinvoices")
        .then((response) => {
          var value = response.data[0].get_totalunpaidinvoices;
          commit("SET_VALUE_UNPAID_INVOICE", value);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  fetchVolumeTotal({ commit }) {
    return new Promise((resolve, reject) => {
      axios
        .get("/totalvolumeofquotation")
        .then((response) => {
          var quotationvolumetotal = response.data;
          commit("SET_VOLUME_TOTAL", quotationvolumetotal);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  async fetchQuotation({ commit }) {
    try {
      const response = await axios.get("/dashboardsmart");
      let quotations = response.data;

      // Vérification que quotations est un tableau
      if (!Array.isArray(quotations)) {
        console.warn("Les données reçues ne sont pas un tableau:", quotations);
        quotations = [];
      }

      // Tri des quotations selon la logique demandée
      const parseDate = (value) => {
        if (!value) return null;
        const date = new Date(value);
        return Number.isNaN(date.getTime()) ? null : date;
      };

      const getTransportKey = (item) => {
        if (!item) return null;

        const candidates = [];

        if (item.idtransport !== undefined && item.idtransport !== null) {
          candidates.push(item.idtransport);
        }

        if (item.transport) {
          if (item.transport.id !== undefined && item.transport.id !== null) {
            candidates.push(item.transport.id);
          }

          if (
            item.transport.transporter_id !== undefined &&
            item.transport.transporter_id !== null
          ) {
            candidates.push(item.transport.transporter_id);
          }

          if (Array.isArray(item.transport.people)) {
            item.transport.people.forEach((person) => {
              if (!person) return;
              if (person.id !== undefined && person.id !== null) {
                candidates.push(person.id);
              }
              if (person.idperson !== undefined && person.idperson !== null) {
                candidates.push(person.idperson);
              }
            });
          }
        }

        if (item.transporter_id !== undefined && item.transporter_id !== null) {
          candidates.push(item.transporter_id);
        }

        for (const candidate of candidates) {
          const numeric = Number(candidate);
          if (!Number.isNaN(numeric)) {
            return { type: "number", value: numeric };
          }
        }

        for (const candidate of candidates) {
          if (candidate !== null && candidate !== undefined) {
            return { type: "string", value: String(candidate).toLowerCase() };
          }
        }

        return null;
      };

      const getDesiredDate = (item) =>
        parseDate(item && item.date_delivery_desired);

      quotations.sort((a, b) => {
        const transportDateA = parseDate(
          a && a.transport ? a.transport.date : null
        );
        const transportDateB = parseDate(
          b && b.transport ? b.transport.date : null
        );

        if (transportDateA && transportDateB) {
          if (transportDateA < transportDateB) return -1;
          if (transportDateA > transportDateB) return 1;
        } else if (transportDateA) {
          return -1;
        } else if (transportDateB) {
          return 1;
        }

        const transportKeyA = getTransportKey(a);
        const transportKeyB = getTransportKey(b);

        if (transportKeyA && transportKeyB) {
          if (
            transportKeyA.type === "number" &&
            transportKeyB.type === "number"
          ) {
            if (transportKeyA.value < transportKeyB.value) return -1;
            if (transportKeyA.value > transportKeyB.value) return 1;
          } else if (transportKeyA.type === "number") {
            return -1;
          } else if (transportKeyB.type === "number") {
            return 1;
          } else if (transportKeyA.value < transportKeyB.value) {
            return -1;
          } else if (transportKeyA.value > transportKeyB.value) {
            return 1;
          }
        } else if (transportKeyA) {
          return -1;
        } else if (transportKeyB) {
          return 1;
        }

        const desiredDateA = getDesiredDate(a);
        const desiredDateB = getDesiredDate(b);

        if (desiredDateA && desiredDateB) {
          if (desiredDateA < desiredDateB) return -1;
          if (desiredDateA > desiredDateB) return 1;
        } else if (desiredDateA) {
          return -1;
        } else if (desiredDateB) {
          return 1;
        }

        return 0;
      });

      // Commit des données triées au store Vuex
      commit("SET_QUOTATION_DASHBOARD", quotations);

      return response;
    } catch (error) {
      console.error("Erreur lors de la récupération des quotations:", error);
      throw error;
    }
  },
  /*
  fetchQuotation({ commit }) {
    return new Promise((resolve, reject) => {
      axios
        .get("/dashboardsmart")
        .then((response) => {
          //var q = response.data
          var quotation = response.data;
          var q = quotation.sort((a, b) =>
            a.date_delivery_desired < b.date_delivery_desired
              ? -1
              : a.date_delivery_desired > b.date_delivery_desired
              ? 1
              : 0
          );
          //q.length = 20
          commit("SET_QUOTATION_DASHBOARD", q);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },*/
  fetchQuotationProductPrint({ commit }) {
    return new Promise((resolve, reject) => {
      axios
        .get("/dashboardsmartproductprint")
        .then((response) => {
          let quotations = response.data;

          if (!Array.isArray(quotations)) {
            console.error("Les données reçues ne sont pas un tableau :", quotations);
            return reject(new Error("Format de données invalide."));
          }

          // Tri des quotations

      // Tri des quotations selon la logique SQL spécifiée
      quotations.sort((a, b) => {
        // Étape 1 : Prioriser les lignes avec un transport
        const aHasTransport = a.idtransport != null;
        const bHasTransport = b.idtransport != null;

        if (aHasTransport && !bHasTransport) return -1; // a a transport, b non
        if (!aHasTransport && bHasTransport) return 1; // b a transport, a non

        // Étape 2 : Trier par date de transport si idtransport existe
        const dateA = aHasTransport && a.transport && a.transport.date ? new Date(a.transport.date) : null;
        const dateB = bHasTransport && b.transport && b.transport.date ? new Date(b.transport.date) : null;

        if (dateA && dateB) {
          if (dateA < dateB) return -1;
          if (dateA > dateB) return 1;
        }

        // Étape 3 : Trier par date_delivery_desired si idtransport est null
        const dateADelivery = a.date_delivery_desired ? new Date(a.date_delivery_desired) : new Date(Infinity);
        const dateBDelivery = b.date_delivery_desired ? new Date(b.date_delivery_desired) : new Date(Infinity);

        if (!isNaN(dateADelivery) && !isNaN(dateBDelivery)) {
          if (dateADelivery < dateBDelivery) return -1;
          if (dateADelivery > dateBDelivery) return 1;
        } else if (!isNaN(dateADelivery)) {
          return -1; // a a une date valide, b non
        } else if (!isNaN(dateBDelivery)) {
          return 1; // b a une date valide, a non
        }

        return 0; // Si tout est égal
      });

          // Log des résultats pour débogage
          console.log("Données après tri :", quotations);

          commit("SET_QUOTATION_DASHBOARD_PRODUCT_PRINT", quotations);
          resolve(response);
        })
        .catch((error) => {
          console.error("Erreur lors de la récupération des quotations :", error);
          reject(error);
        });
    });
  },
  fetchQuotationProductPrintv2({ commit }) {
    return new Promise((resolve, reject) => {
      axios
        .get("/dashboardsmartproductprintv2")
        .then((response) => {
          var quotationproduct = response.data;
          var q = quotationproduct.sort((a, b) =>
            a.date_delivery_desired < b.date_delivery_desired
              ? -1
              : a.date_delivery_desired > b.date_delivery_desired
              ? 1
              : 0
          );
          commit("SET_QUOTATION_DASHBOARD_PRODUCT_PRINT_v2", q);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  fetchQuotationProductPrintv3({ commit }) {
    return new Promise((resolve, reject) => {
      axios
        .get("/dashboardsmartproductprintv2")
        .then((response) => {
          var quotationproduct = response.data;
          quotationproduct.sort((a, b) => {
            // Comparaison par 'category' d'abord
            if (a.categoryro < b.categoryro) return -1;
            if (a.categoryro > b.categoryro) return 1;

            // Si 'category' est identique pour les deux éléments, comparer par 'volumetoprepare' (descendant)
            return b.volumetoprepare - a.volumetoprepare;
          });
          commit("SET_QUOTATION_DASHBOARD_PRODUCT_PRINT_v3", quotationproduct);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  fetchQuotationProduct({ commit }) {
    return new Promise((resolve, reject) => {
      axios
        .get("/dashboardsmartproduct")
        .then((response) => {
          var quotationproduct = response.data;
          var q = quotationproduct.sort((a, b) =>
            a.date_delivery_desired < b.date_delivery_desired
              ? -1
              : a.date_delivery_desired > b.date_delivery_desired
              ? 1
              : 0
          );
          commit("SET_QUOTATION_DASHBOARD_PRODUCT", q);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  fetchKPI({ commit }) {
    return new Promise((resolve, reject) => {
      axios
        .get("/dashboardkpiv2")
        .then((response) => {
          var kpi = response.data;
          commit("SET_KPI", kpi);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  fetchSolarStations({ commit }) {
    return new Promise((resolve, reject) => {
      axios
        .get("/solar/stations")
        .then((response) => {
          commit("SET_SOLAR_STATIONS", response.data || []);
          resolve(response);
        })
        .catch((error) => { reject(error); });
    });
  },
  fetchSolarRealtime({ commit }, stationId) {
    return new Promise((resolve, reject) => {
      axios
        .get(`/solar/realtime/${stationId}`)
        .then((response) => {
          commit("SET_SOLAR_REALTIME", response.data || {});
          resolve(response);
        })
        .catch((error) => { reject(error); });
    });
  },
  fetchSolarHistory({ commit }, stationId) {
    return new Promise((resolve, reject) => {
      axios
        .get(`/solar/history/${stationId}`)
        .then((response) => {
          commit("SET_SOLAR_HISTORY", response.data || []);
          resolve(response);
        })
        .catch((error) => { reject(error); });
    });
  },
  fetchSolarHistoryDay({ commit }, stationId) {
    return new Promise((resolve, reject) => {
      axios
        .get(`/solar/history-day/${stationId}`)
        .then((response) => {
          commit("SET_SOLAR_HISTORY_DAY", response.data || []);
          resolve(response);
        })
        .catch((error) => { reject(error); });
    });
  },
  fetchSolarForecast({ commit }, stationId) {
    return new Promise((resolve, reject) => {
      axios
        .get(`/solar/forecast/${stationId}`)
        .then((response) => {
          commit("SET_SOLAR_FORECAST", response.data || null);
          resolve(response);
        })
        .catch((error) => { reject(error); });
    });
  },
  fetchSolarScores({ commit }) {
    return new Promise((resolve, reject) => {
      axios
        .get("/solar/scores")
        .then((response) => {
          commit("SET_SOLAR_SCORES", response.data || { items: [], worst: null });
          resolve(response);
        })
        .catch((error) => { reject(error); });
    });
  },
  fetchSolarCriticalAlerts({ commit }) {
    return new Promise((resolve, reject) => {
      axios
        .get("/solar/alerts/active")
        .then((response) => {
          commit("SET_SOLAR_CRITICAL_ALERTS", response.data || { count: 0, items: [] });
          resolve(response);
        })
        .catch((error) => { reject(error); });
    });
  },
};
